import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const usePaymentsStore = defineStore('payments', () => {
    const paymentMethods = ref(null);
    const transactions = ref([]);

    const actions = {
        storePaymentMethod: (params) => axios.post('api/v1/payment-methods', params),
        makeDefaultPaymentMethod: (id) => axios.patch(`api/v1/payment-methods/${id}/default`),
        removePaymentMethod: (id) => axios.delete(`api/v1/payment-methods/${id}`),
    };

    const reset = () => {
        paymentMethods.value = null;
        transactions.value = [];
    };

    return {
        paymentMethods,
        transactions,
        reset,
        ...actions,
    };
});
